module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/shopping/box-3-eb51bb567460da2972ef76f2632c724b.svg";